import { Model } from 'app/model/backendmodel';
import { AdapterRegistry } from '../../../adapter-registry';
import { Metamodel } from 'app/model/base/model';
import { CopySink } from 'app/model/pipeline/copysink/copysink';
import { FormatWriteSettingsAdapter, formatWriteSettingsAdapts } from './format-write-settings.adapter';
import { ValueAdapter } from 'app/model/adapters/value.adapter';
import { JsonFormatWriteSettings } from 'app/model/pipeline/copysink/format-write-settings/json-format-write-settings';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(JsonFormatWriteSettings),
    asynchronous: true,
    adapts: {
        pattern: '*',
        ...formatWriteSettingsAdapts
    }
})
export class JsonFormatWriteSettingsAdapter extends FormatWriteSettingsAdapter<
    JsonFormatWriteSettings,
    Model.FormatWriteSettings
> {
    protected override async _toResource(model: JsonFormatWriteSettings): Promise<Model.FormatWriteSettings> {
        const result: Model.JsonFormatWriteSettings = FormatWriteSettingsAdapter.getCommonWriteSettingsProperties(
            Metamodel.modelFor(JsonFormatWriteSettings).name
        );
        FormatWriteSettingsAdapter.toFormatWriteSettingsResource(model, result);
        result.filePattern = ValueAdapter.toResource(model, JsonFormatWriteSettings.PATTERN);
        return result;
    }

    protected override async _toModel(
        resource: Model.JsonFormatWriteSettings,
        copySink: CopySink
    ): Promise<JsonFormatWriteSettings> {
        const result = FormatWriteSettingsAdapter.createWriteSettingsWithCommonProperties(
            JsonFormatWriteSettings.MODEL,
            copySink
        ) as JsonFormatWriteSettings;
        FormatWriteSettingsAdapter.toFormatWriteSettingsModel(resource, result);
        ValueAdapter.toModel(result, JsonFormatWriteSettings.PATTERN, resource.filePattern);
        return result;
    }
}
